import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { AdminAPI } from "../../api/api";
import Administrador from "../../models/Administrador";

export default function ManageAccounts() {
  const [users, setUsers] = useState([]);
  const [newName, setNewName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Obtener usuarios desde API
  const fetchUsers = async () => {
    try {
      const data = await AdminAPI.getAll();
      setUsers(data);
    } catch (err) {
      console.error("Error al obtener administradores:", err);
      alert("No se pudieron cargar los administradores.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Crear nuevo administrador
  const handleAddUser = async () => {
    if (!newName || !newEmail || !newPassword) {
      alert("Completa todos los campos");
      return;
    }

    setLoading(true);
    try {
      const newAdmin = new Administrador(null, newName, newEmail, newPassword);
      await AdminAPI.create(newAdmin);

      setNewName("");
      setNewEmail("");
      setNewPassword("");
      fetchUsers(); // refrescar lista
    } catch (err) {
      console.error("Error al crear administrador:", err);
      alert("Hubo un error al crear el administrador.");
    } finally {
      setLoading(false);
    }
  };

  // Eliminar administrador
  const handleDeleteUser = async (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este administrador?")) return;

    try {
      await AdminAPI.delete(id);
      fetchUsers();
    } catch (err) {
      console.error("Error al eliminar administrador:", err);
      alert("Hubo un error al eliminar el administrador.");
    }
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-success">Administrar Cuentas</h2>

      {/* Formulario de nuevo usuario */}
      <div className="card mb-5 shadow-sm">
        <div className="card-body">
          <h5 className="card-title">Añadir nuevo administrador</h5>
          <div className="row g-3 align-items-center">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Nombre completo"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <input
                type="email"
                className="form-control"
                placeholder="Correo"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <input
                type="password"
                className="form-control"
                placeholder="Contraseña"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="col-md-1 d-grid">
              <button
                className="btn btn-success"
                onClick={handleAddUser}
                disabled={loading}
              >
                {loading ? "Añadiendo..." : "Añadir"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Lista de administradores */}
      <div className="row row-cols-1 row-cols-md-2 g-4">
        {users.map((user) => (
          <div className="col" key={user.id}>
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <strong>{user.nombreCompleto}</strong>
                  <br />
                  <small className="text-muted">{user.correo}</small>
                </div>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteUser(user.id)}
                >
                  Eliminar
                </button>
              </div>
              <div className="card-footer text-muted">
                ID: {user.id}
              </div>
            </div>
          </div>
        ))}
      </div>

      {users.length === 0 && (
        <p className="text-center text-muted mt-4">
          No hay administradores registrados.
        </p>
      )}
    </div>
  );
}
